import user from './rules.user'
import group from './rules.group'
import colors from './rules.colors'
import fileTree from './rules.filetree'
import fileTreeChange from './rules.filetreechange'
import date from './rules.date'

export default { user, group, colors, fileTree, fileTreeChange, date }